import { twMerge } from "tailwind-merge";
import { FieldErrorBase } from "@core/ui";
import { Type } from "../Type";

export type Props = {
  /** Error message to display */
  message?: string;
  /** ID for aria-describedby association with input */
  id?: string;
  /** Additional CSS classes */
  className?: string;
};

/**
 * Styled field error component.
 * Use id prop with aria-describedby on the input for accessibility.
 *
 * @example
 * <Input aria-describedby="email-error" ... />
 * <FieldError id="email-error" message={error?.message} />
 */
export function FieldError({ message, id, className }: Props) {
  if (!message) return null;

  return (
    <FieldErrorBase
      as={Type}
      variant="caption"
      id={id}
      message={message}
      className={twMerge("text-error-600 field-error-message", className)}
    />
  );
}

export default FieldError;

